<template>
  <div class="additional-dtek">
    <sDivider/>
    <template v-for="(valueItem, valueIndex) in valueSorted">
      <AditionalFieldsDtekItem
        :key="`${valueItem.id}-${valueIndex}-fio`"
        :value-index="valueIndex"
        :value-item="valueItem"/>
      <CollapseBlock
        v-if="valueItem.history && valueItem.history.length"
        :key="`${valueItem.id}-${valueIndex}-history`"
        :value.sync="historyShow[valueIndex]">
        <div
          slot="title"
          class="pt-2 font-size-14">
          {{ $t('Tenders.History') }}
        </div>
        <AditionalFieldsDtekItem
          v-for="(historyItem, historyIndex) in valueItem.history"
          :key="`${valueItem.id}-${valueIndex}-${historyIndex}-history`"
          show-history
          :value-index="historyIndex"
          :value-item="historyItem"/>
      </CollapseBlock>
    </template>
  </div>
</template>
<script>
import CollapseBlock from 'components/common/CollapseBlock.vue'
import AditionalFieldsDtekItem from 'components/tenders/tender page/AditionalFieldsDtekItem.vue'

/**
 * Результат анкеты на согласовании. ДТЕК
 */
export default {
  name: 'AdditionalFieldsDtek',
  data() {
    return {
      historyShow: []
    }
  },
  components: {
    CollapseBlock,
    AditionalFieldsDtekItem
  },
  props: {
    value: {
      type: Array
    }
  },
  computed: {
    values() {
      return this.value?.map(i => ({id: i.id, ...i.value})) || []
    },
    valueSorted() {
      if (!this.values?.length) {
        return []
      }
      const outputData = this.$_.cloneDeep(this.values)
        .sort((a, b) => new Date(b.datetime).getTime() - new Date(a.datetime).getTime())
        .reduce((acc, currentItem) => {
          const key = `${currentItem.fio}-${currentItem.role}`
          const existingItem = acc.find((item) => `${item.fio}-${item.role}` === key)

          if (existingItem) {
            if (new Date(currentItem.datetime) > new Date(existingItem.datetime)) {
              existingItem.datetime = currentItem.datetime
              existingItem.decisionStatus = currentItem.decisionStatus
              existingItem.answers = currentItem.answers
            }

            existingItem.history = existingItem.history || []
            existingItem.history.push({decisionStatus: currentItem.decisionStatus, datetime: currentItem.datetime, answers: [...currentItem.answers]})
          } else {
            const newItem = {
              fio: currentItem.fio,
              decisionStatus: currentItem.decisionStatus,
              role: currentItem.role,
              datetime: currentItem.datetime,
              answers: currentItem.answers,
              history: [],
            }
            this.historyShow.push(false)
            acc.push(newItem)
          }

          return acc
        }, [])

      return outputData
    }
  }
}
</script>
<style scoped lang="scss">
.additional-dtek {
  text-align: left;
  padding: 0 8px;
}
</style>
